import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { BANK_CONNECTION_PROVIDER } from "constants/dataSource";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useToast } from "hooks/useToast";
import { useDisconnectBankMutation } from "store/apis/bankConnections";
import { Connection } from "store/apis/booksConnections";
import { BackendError } from "types/utils/error";

export const DisconnectBankModal = ({
  show,
  onClose,
  connection,
}: {
  show: boolean;
  onClose: () => void;
  connection: Connection;
}) => {
  const { uuid: groupId } = useCurrentGroupContext();
  let entityId = useCurrentEntityId();
  const [disconnectBank, { isLoading }] = useDisconnectBankMutation();
  const { successToast, alertToast } = useToast();

  const onDisconnect = async () => {
    if (entityId) {
      try {
        await disconnectBank({
          groupId: groupId,
          entityId: entityId,
          bankId: connection.uuid,
        }).unwrap();

        successToast({
          message: `${connection.name} disconnected successfully!`,
        });
        onClose();
      } catch (error) {
        alertToast({ message: (error as BackendError).data?.error?.message });
      }
    }
  };
  const isBillCom =
    connection?.connection_provider === BANK_CONNECTION_PROVIDER.BILL_DOT_COM;
  const integrationTypes =
    connection?.connection_provider === BANK_CONNECTION_PROVIDER.BILL_DOT_COM ||
    connection?.connection_provider === BANK_CONNECTION_PROVIDER.HUBSPOT ||
    connection?.connection_provider === BANK_CONNECTION_PROVIDER.STRIPE;

  return (
    <Modal.Root open={show} onOpenChange={onClose}>
      <Modal.Content>
        <Modal.Header className="sm:t-pl-4">
          <Modal.Title>
            {integrationTypes ? "Disconnect Integration" : "Disconnect bank"}
          </Modal.Title>
          <Modal.Close />
        </Modal.Header>
        {isBillCom ? (
          <Modal.Body className="t-flex t-gap-4 t-flex-col sm:t-px-4">
            <div className="t-text-text-black t-text-body-sm">
              Are you sure you want to disconnect
              <b> {connection.name}?</b>
            </div>
            <div className="t-text-text-black t-text-body-sm">
              Invoices/Bills raised on Bill.com will no longer be synced to
              Inkle
            </div>
          </Modal.Body>
        ) : (
          <Modal.Body className="t-flex t-gap-4 t-flex-col sm:t-px-4">
            <div className="t-text-text-black t-text-body-sm">
              Are you sure you want to disconnect
              <b> {connection.name}?</b>
            </div>
            <div className="t-text-text-black t-text-body-sm">
              This will disconnect bank accounts from inkle and new transactions
              won't be pulled.
            </div>
          </Modal.Body>
        )}
        <Modal.Footer className="sm:t-px-4">
          <div className="t-flex t-gap-3 t-justify-end t-w-full">
            <Button onClick={onClose} disabled={isLoading}>
              Cancel
            </Button>
            <Button
              customType="danger"
              onClick={onDisconnect}
              isLoading={isLoading}
              disabled={isLoading}
            >
              Disconnect
            </Button>
          </div>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
